import { MapUtils } from '../../../utility/map-utils.js';

import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/data-model.js';

export class AdCredit extends DataModel {
  static readonly TYPE_ID: string = '897acfd4108d4f7391a24779cd840d81';

  private constructor(
    public readonly adCredit: number,
  ) {
    super();
  }

  get $typeId(): string {
    return AdCredit.TYPE_ID;
  }

  static create(args: {
    adCredit?: number,
  }): AdCredit {
    return new AdCredit(
        args.adCredit ?? 0
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): AdCredit {
    return AdCredit.create({
      adCredit: MapUtils.getDouble(map, 'adCredit'),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'adCredit': this.adCredit,
    };
  }

  clone(): this {
    return this.copyWith();
  }

  copyWith({
    adCredit = this.adCredit,
  }: {
    adCredit?: number,
  } = {}): this {
    return AdCredit.create({
      adCredit,
    }) as this;
  }

  isSame(other: AdCredit): boolean {
    if(other === this) {
      return true;
    }

    return other.adCredit === this.adCredit;
  }
}

export class AdCreditBuilder extends DataModelBuilder<AdCredit> {
  build(context: SerializationContext, map: SerializedData): AdCredit {
    return AdCredit.fromMap(context, map);
  }
}
